import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutCondensedComponent, NotFoundComponent } from './layouts';
import { ContPatientAppoinmentCreateComponent } from './containers/patient-appointment/create';

const routes: Routes = [
  {
    path: "",
    component: LayoutCondensedComponent,
    children: [
      {
        path: "",
        component: ContPatientAppoinmentCreateComponent,
        data: { breadcrumb: "patient-appointment-create" },
      },
      {
        path: "patient-appointment-create",
        component: ContPatientAppoinmentCreateComponent,
        data: { breadcrumb: "patient-appointment-create" },
      },
      { path: '**', component: NotFoundComponent },
    ]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
